'use client';
import { useEffect } from 'react';
import { EVENT_SYNC_ERROR, isErrorPayload } from '../lib/getQueryClient.js';
/**
 * Public function to use to subscribe to sync errors.
 * Can be used to display global errors within the MFE application.
 *
 * Atm this hook will only display errors from Tanstack, but in the future it should also work for other use cases and technologies.
 *
 * @param onSyncError Error callback, should be cached via useCallback
 */
export function useOnSyncError(onSyncError) {
    useEffect(() => {
        const controller = new AbortController();
        window.addEventListener(EVENT_SYNC_ERROR, (event) => {
            const customEvent = event;
            if (isErrorPayload(customEvent.detail)) {
                onSyncError(customEvent.detail);
            }
        }, { signal: controller.signal });
        return () => {
            controller.abort();
        };
    });
}
//# sourceMappingURL=useOnSyncError.js.map